import { render, staticRenderFns } from "./zcfg.vue?vue&type=template&id=30bf3e14&scoped=true&"
import script from "./zcfg.vue?vue&type=script&lang=js&"
export * from "./zcfg.vue?vue&type=script&lang=js&"
import style0 from "./zcfg.vue?vue&type=style&index=0&id=30bf3e14&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30bf3e14",
  null
  
)

export default component.exports